import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import SiteFooter from '@/components/feature/SiteFooter';
import SiteNavbar from '@/components/feature/SiteNavbar';
import { ContactHero, ContactMain, ContactMap } from './components/Sections';

export default function Contact() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const id = hash.replace('#', '');
    const timer = window.setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 120);
    return () => window.clearTimeout(timer);
  }, [pathname, hash]);

  return (
    <div className="min-h-screen bg-background-50">
      <SiteNavbar />
      <main>
        <ContactHero />
        <ContactMain />
        <ContactMap />
      </main>
      <SiteFooter />
    </div>
  );
}